interface Action<T extends string> {
    type: T
}

export const createAction = <T extends string, P extends Record<string, unknown>>(type: T, props?: P): Action<T> & P =>
    Object.assign({ type }, props)
